export default __webpack_public_path__ + "static/media/324.47908219.png";